import React from 'react'
import { Tooltip } from '@surecompanies/core_components'
import { WarningFilled } from '@ant-design/icons'

import { DASH, SOURCE_REPORTED_WARNING } from './helpers'
import styles from './ReviewQueue.module.scss'

/**
 * The amber flag beside a source-reported value. Named for screen readers by
 * the same sentence the tooltip shows, so the warning is not mouse-only.
 */
export const SourceReportedWarning: React.FC = () => (
  <Tooltip title={SOURCE_REPORTED_WARNING}>
    <WarningFilled
      aria-label={SOURCE_REPORTED_WARNING}
      className={styles.sourceReportedIcon}
    />
  </Tooltip>
)

/**
 * A name as the payment's source record states it, flagged as unverified,
 * shown in full like the resolved names beside it. Plain text only — never a link, since it names no one we have resolved. A
 * field the source left empty is a bare dash with no flag: there is nothing
 * to warn about.
 */
export const SourceReportedText: React.FC<{ value: string | null }> = ({
  value,
}) =>
  value === null ? (
    <>{DASH}</>
  ) : (
    <span className={styles.sourceReportedLine}>
      <span className={styles.fullText}>{value}</span>
      <SourceReportedWarning />
    </span>
  )
